module.exports = __webpack_public_path__ + "8ca4166a0f578057ec115d028e947fbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/docs/xml-validation/xmlValidatorCoreFiling.png
// module id = 2477
// module chunks = 0